<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title text-break" *ngIf="editMode"><strong>Editar
          Empresa</strong></h5>
      <h5 class="modal-title text-break" *ngIf="!editMode"><strong>Nova
          Empresa</strong></h5>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="form" *ngIf="!loading">
        <div class="row">
          <div class="col-lg-10">
            <div class="form-group">
              <app-input type="text" formControlName="name" inputRequired=true
                label="Nome"></app-input>
              <div class="text-danger"
                *ngIf="form.get('name')?.invalid && existCompany" i18n>
                Já existe uma empresa cadastrada com o mesmo nome.
              </div>
              <div class="loading-spinner" *ngIf="findCompany">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
            </div>
            <div class="form-group">
              <app-input type="number" formControlName="cnpj" inputRequired=true
                label="CNPJ"></app-input>
            </div>
          </div>
          <div class="col-lg-2">
            <label class="form-control-label required" i18n>Habilitado:</label>
            <div class="custom-control custom-switch">
              <label class="custom-control-label"
                [ngClass]="{ checked: enabledCompany }">
                <input type="checkbox" class="form-control custom-control-input"
                  (change)="enabledOrDisabledCompany(company)">
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div class="form-group">
              <app-input type="text" formControlName="street"
                label="Endereço"></app-input>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <app-input type="text" formControlName="number"
                label="N°"></app-input>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <app-input type="text" formControlName="zipcode"
                label="CEP"></app-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <app-input i18n-label i18n-placeholder label="País"
                formControlName="regionId"
                type="select" selectText="name" selectValue="id"
                [list]="regions" selectShowLimit="5">
              </app-input>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <app-input i18n-label i18n-placeholder label="Estado"
                formControlName="stateId"
                type="select" selectText="name" selectValue="id"
                [list]="states" selectShowLimit="5">
              </app-input>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <app-input i18n-label i18n-placeholder label="Cidade"
                formControlName="cityId"
                type="select" selectText="name" selectValue="id"
                [list]="cities" selectShowLimit="5">
              </app-input>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <app-input type="text" formControlName="neighborhood"
                label="Bairro"></app-input>
            </div>
          </div>
        </div>
        <div class="loading-page" *ngIf="isLoading">
          <div class="loading-spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <h6 i18n>Logo:</h6>
            <app-file-upload i18n-text="@@TextSingleLabel"
              formControlName="logo"
              [files]=logoFile (outputFiles)="logoFile = $event"
              accept="image/jpg, image/jpeg, image/png, image/gif"
              text="Selecione apenas um arquivo." limit="1">
            </app-file-upload>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-12 d-flex justify-content-end">
            <div class="buttons">
              <button class="btn btn-outline-secondary mr-2"
                (click)="onCancel()">Cancelar</button>
              <button class="btn btn-primary" (click)="onSubmit()"
                [disabled]="form.invalid || findCompany || existCompany">
                <span *ngIf="!loadingPromise">Confirmar</span>
                <div class="loading-spinner" *ngIf="loadingPromise">
                  <div class="bounce1"></div>
                  <div class="bounce2"></div>
                  <div class="bounce3"></div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </form>
      <div class="loading-page" *ngIf="loading">
        <div class="loading-spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
    </div>
  </div>
</div>
